import { FaBuilding, FaBuildingColumns, FaCity, FaHouse, FaMapLocation } from 'react-icons/fa6';

export const defaultPlaceType = { label: 'Building', Icon: FaBuilding };

export const placeTypes = {
  DefaultLocationUserHome: { label: 'Building', Icon: FaHouse },
  locality: { label: 'City', Icon: FaCity },
  administrative_area_level_1: { label: 'State', Icon: FaBuildingColumns },
  administrative_area_level_2: { label: 'County', Icon: FaBuildingColumns },
  premise: defaultPlaceType,
  country: { label: 'Country', Icon: FaBuilding },
  geocode: { label: 'Location', Icon: FaMapLocation },
};
